<app-stepper [steps]="steps" (stepClick)="onStepClick($event)"></app-stepper>
<div class="row mt-3">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>